module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-ogp-72df26cb1e3a9f4b19e67a2a493afb1b.jpg";